import { render, staticRenderFns } from "./AuthorizationsReport.vue?vue&type=template&id=0915564a&scoped=true&"
import script from "./AuthorizationsReport.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsReport.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsReport.vue?vue&type=style&index=0&id=0915564a&lang=scss&scoped=true&"
import style1 from "./AuthorizationsReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0915564a",
  null
  
)

export default component.exports